let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
import { useBehavior } from '../extensions/hooks/useBehavior';
import BehaviorRenderer from '../extensions/components/BehaviorRenderer';
import { Banner } from '../extensions/constants/BehaviorTypes';
import { useIsUngatedForIARedesign } from '../auth/hooks/useIsUngatedForIARedesign';
import { jsx as _jsx } from "react/jsx-runtime";
const ConditionalPaddingWrapper = styledWithTheme.div(_t || (_t = _`
  padding: ${0};
  padding-block-end: 0;
  background-color: ${0};

  &:empty {
    padding: 0;
  }
`), ({
  theme
}) => theme.space['200'], ({
  theme,
  isUngatedForRedesign
}) => isUngatedForRedesign ? theme.color['fill-surface-recessed'] : theme.color['fill-surface-default']);
export const BannerComponent = () => {
  const BannerBehavior = useBehavior(Banner);
  const isUngatedForRedesign = useIsUngatedForIARedesign();
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(ConditionalPaddingWrapper, {
      isUngatedForRedesign: isUngatedForRedesign,
      children: /*#__PURE__*/_jsx(BehaviorRenderer, {
        Component: BannerBehavior
      })
    })
  );
};